import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAuthStore = create(
    persist(
        (set) => ({
            user: null,
            token: null,
            isGuest: false, // ضفنا الحالة دي

            // تسجيل الدخول العادي
            login: (user, token) => set({ user, token, isGuest: false }),

            // الدخول كزائر (بدون توكن)
            loginAsGuest: () => set({ 
                user: { name: 'Guest User', role: 'guest' }, 
                token: null, 
                isGuest: true 
            }),

            // تسجيل الخروج
            logout: () => set({ user: null, token: null, isGuest: false }),
        }),
        {
            name: 'auth-storage',
        }
    )
);

export default useAuthStore;